import { useEffect } from "react"

// The hook only reads ref.current; accept React.RefObject (read-only) so
// `useRef<HTMLDivElement>(null)` call sites type-match without forcing them
// into MutableRefObject.
export type Args<T> = {
  ref: React.RefObject<HTMLElement | HTMLUListElement | HTMLDivElement>
  callback: (
    ref: React.RefObject<HTMLElement | HTMLUListElement | HTMLDivElement>
  ) => void
  shouldFire: boolean
}

export const useHandleOutsideClick = <T,>({
  callback,
  ref,
  shouldFire
}: Args<T>) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // handle the usecase where `shouldFire` is not being set as a boolean correctly
      const shouldFireCallback =
        typeof shouldFire === "boolean" ? shouldFire : true

      if (
        ref?.current &&
        !ref?.current?.contains(event.target as Node | null) &&
        shouldFireCallback
      ) {
        callback(ref)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [ref, shouldFire])
}
